import { Fragment } from 'react';

/**
 * A document ID is machine data that an operator copies and compares, so it stays on one line where
 * it fits. Where it does not fit, it breaks only after a `/`, `-`, or `_`: a `<wbr>` marks each
 * place. The text content is the ID unchanged. Put `aria-label={id}` on the link around it: a
 * screen reader then reads the ID whole.
 */
export function DocId({ id }: { id: string }) {
  return (
    <>
      {id.split(/(?<=[/_-])/).map((part, index) => (
        <Fragment key={index}>
          {index > 0 && <wbr aria-hidden="true" />}
          {part}
        </Fragment>
      ))}
    </>
  );
}
